import React, { useState, useEffect } from "react";
// outsource
import { Row, Col, Table, Spin } from "antd";
import { CheckOutlined } from "@ant-design/icons";
// redux
import { useDispatch, useSelector } from "react-redux";
import { snapHolidays, unSnapHolidays } from "../../../store/payout_setting/payout_setting.action";
import { holidaysSelector, holidaysLoadingSelector } from "../../../store/payout_setting/payout_setting.selector";
// functions
import { formatHolidayDate, isHolidayPast } from "../functions/payout_setting_format";

const CURRENT_YEAR = new Date().getFullYear();
const YEARS = [CURRENT_YEAR, CURRENT_YEAR + 1];

const PayoutSettingPublicHolidaysTab = () => {
  // -------------------------- STATE --------------------------
  const [selectedYear, setSelectedYear] = useState(CURRENT_YEAR);

  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const rawData = useSelector(holidaysSelector(selectedYear));
  const currentData = rawData || [];
  const loading = useSelector(holidaysLoadingSelector);

  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    dispatch(snapHolidays({ year: selectedYear }));
    return () => dispatch(unSnapHolidays());
  }, [dispatch, selectedYear]);

  // -------------------------- RENDER --------------------------
  const renderYearSelector = () => {
    return (
      <Row justify="end" gutter={[16, 0]} style={{ marginBottom: 12 }}>
        {YEARS.map((y) => (
          <Col key={y}>
            <span
              className={`ps-ph-year-btn${selectedYear === y ? " active" : ""}`}
              onClick={() => setSelectedYear(y)}
            >
              {y}
            </span>
          </Col>
        ))}
      </Row>
    );
  };

  const renderTable = () => {
    const columns = [
      {
        title: "Holiday",
        dataIndex: "name",
        key: "name",
        width: "40%",
        onHeaderCell: () => ({ className: "ps-ph-header-cell" }),
        render: (val, record) => (
          <span>
            {isHolidayPast(record.date) && <CheckOutlined style={{ marginRight: 8 }} />}
            {val}
          </span>
        ),
      },
      {
        title: "Date",
        dataIndex: "date",
        key: "date",
        width: "60%",
        onHeaderCell: () => ({ className: "ps-ph-header-cell" }),
        render: (val) => formatHolidayDate(val),
      },
    ];

    return (
      <Spin spinning={loading}>
        <Table
          columns={columns}
          dataSource={currentData}
          rowKey="id"
          pagination={false}
          size="small"
          className="ps-ph-table"
          rowClassName={(record) =>
            isHolidayPast(record.date) ? "ps-ph-row-checked" : "ps-ph-row-unchecked"
          }
        />
      </Spin>
    );
  };

  const renderSource = () => {
    const url = `https://publicholiday.co.nz/nz-public-holidays-${selectedYear}.html`;
    return (
      <div className="ps-ph-source">
        Source:{" "}
        <a href={url} target="_blank" rel="noopener noreferrer">
          {url}
        </a>
      </div>
    );
  };

  const renderBody = () => {
    return (
      <Row>
        <Col xl={24} lg={24} md={24} xs={24}>
          <div className="ps-section">
            {renderYearSelector()}
            {renderTable()}
          </div>
        </Col>
        <Col xl={24} lg={24} md={24} xs={24}>
          {renderSource()}
        </Col>
      </Row>
    );
  };

  // -------------------------- MAIN --------------------------
  return renderBody();
};

export default PayoutSettingPublicHolidaysTab;
